import { ref } from 'vue';

export function useNumberAnimation(initialValue = 0, duration = 500) {
  const animatedValue = ref(initialValue);
  let animationFrameId: number | null = null;

  const easeOutQuad = (t: number) => t * (2 - t);

  const animate = (startValue: number, endValue: number) => {
    let startTime: number | null = null;

    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;

      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easing = easeOutQuad(progress);
      const currentValue = easing * (endValue - startValue) + startValue;

      animatedValue.value = Math.floor(currentValue);

      if (progress < 1) {
        animationFrameId = window.requestAnimationFrame(step);
      }
    };

    if (animationFrameId) {
      window.cancelAnimationFrame(animationFrameId);
    }
    animationFrameId = window.requestAnimationFrame(step);
  };

  const updateValue = (newValue: number) => {
    animate(animatedValue.value, newValue);
  };

  return {
    animatedValue,
    updateValue,
  };
}
